import React, { createContext, useState } from 'react'

export interface Tools {
  pageName?: string
  userEmail?: string
  privs?: any
  setPageName?: (...args) => void
  setUserEmail?: (...args) => void
  setPrivs?: (...args) => void
  changePageName?: (...args) => void
}

const defaultTools: Tools = {
  pageName: 'Dashboard',
}

export const AppAuthGlobalVariables = createContext(defaultTools)

const AppAuthContext = ({children}: any) => {
  const regex = /[-/]/g;

  const [pageName, setPageName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [privs, setPrivs] = useState(undefined);
  
  const changePageName = (params:string) => {
    const processedPage = params.replaceAll(regex, ' ');
    setPageName(processedPage);
  }

  const availableTools: Tools = {
    pageName,
    userEmail,
    privs,
    setPageName,
    setUserEmail,
    setPrivs,
    changePageName
  }

  return (<AppAuthGlobalVariables.Provider value={availableTools}>{children}</AppAuthGlobalVariables.Provider>)
}

export default AppAuthContext;